import { Component } from '@angular/core';
import { AppService } from '../../services/app.service';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.html',
	styleUrls: ['./footer.scss']
})

export class FooterComponent {
	public buildTimestamp: any;
	public version: any;
	public year: number;

	constructor(private _appService: AppService) {
		this.buildTimestamp = this._appService.buildTimestamp;
		this.version = this._appService.version;
		this.year = this._appService.year;
	}
}
